import { IImageLeafParagraph } from './types';
import { ApproachImage } from './ApproachImage';
import { ApproachContainerCard } from './ApproachContainerCard';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapImageLeafParagraph } from './mapImageLeafParagraph';

const ImageLeafParagraph: React.FC<IImageLeafParagraph> = ({
  title,
  largeTitle,
  text,
  image,
  alt,
  hasPictureOnRight,
}) => {
  return (
    <section>
      <div className="approach">
        <div className="root">
          <ApproachImage
            image={image}
            alt={alt}
            hasPictureOnRight={hasPictureOnRight}
          />
          <ApproachContainerCard
            title={title}
            largeTitle={largeTitle}
            text={text}
          />
        </div>
        <style jsx>{`
          .approach {
            padding: 100px 0;
          }

          .root {
            display: flex;
            align-items: center;
            position: relative;
            flex-direction: ${hasPictureOnRight ? `row-reverse` : `row`};
          }

          @media (max-width: 800px) {
            .approach {
              margin-bottom: 0;
              padding: 0 0 19px 0;
            }

            .root {
              flex-direction: column;
            }
          }
        `}</style>
      </div>
    </section>
  );
};

export default withSlice(ImageLeafParagraph, mapImageLeafParagraph);
